import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const FRUITS = [
  { id: "watermelon", src: "/img/fruit_watermelon.webp", style: { left: "0%", bottom: "38%", width: "42%" }, from: { x: -120, y: -200 } },
  { id: "pineapple", src: "/img/fruit_pineapple.webp", style: { left: "37%", bottom: "30%", width: "26%" }, from: { x: 0, y: -260 } },
  { id: "apple", src: "/img/fruit_apple.webp", style: { right: "2%", bottom: "40%", width: "27%" }, from: { x: 140, y: -200 } },
];

const BOTTLES = [
  { id: "watermelon", src: "/img/bottle_watermelon.webp", left: "4%", label: "Fresh Watermelon" },
  { id: "pineapple", src: "/img/bottle_pineapple.webp", left: "35%", label: "Fresh Pineapple" },
  { id: "apple", src: "/img/bottle_apple.webp", left: "66%", label: "Fresh Apples" },
];

export const Stage = ({ flavors }) => {
  const groups = ["watermelon", "pineapple", "apple"].map((id) => flavors.find((g) => g.base.toLowerCase() === id));

  return (
    <div>
      <div className="relative w-full aspect-[10/9]" data-testid="hero-stage">
        <div className="absolute inset-0">
          {FRUITS.map((f, i) => (
            <motion.img
              key={f.id}
              data-testid={`hero-fruit-${f.id}`}
              src={f.src}
              alt={`Fresh ${f.id}`}
              className="absolute drop-shadow-[0_30px_40px_rgba(24,18,3,0.35)]"
              style={f.style}
              initial={{ opacity: 0, scale: 0.4, ...f.from, rotate: -25 }}
              animate={{ opacity: 1, scale: 1, x: 0, y: 0, rotate: 0 }}
              transition={{ type: "spring", stiffness: 70, damping: 11, delay: 1.0 + i * 0.12 }}
            />
          ))}
        </div>
        <div className="absolute left-[8%] right-[8%] bottom-[2%] h-[6%] rounded-[50%] bg-[#181203]/30 blur-xl" />
        <div className="absolute inset-0">
          {BOTTLES.map((b, i) => (
            <motion.div
              key={b.id}
              data-testid={`bottle-${b.id}`}
              className="absolute bottom-[3%] w-[30%] group"
              style={{ left: b.left }}
              initial={{ opacity: 0, y: 120 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ type: "spring", stiffness: 90, damping: 14, delay: 1.45 + i * 0.15 }}
            >
              <div
                data-testid={`hero-bottle-zoom-${b.id}`}
                className="pointer-events-none absolute -top-[62%] left-1/2 -translate-x-1/2 z-20 w-[88%] aspect-[3/4] rounded-3xl overflow-hidden border-4 border-[#181203] bg-[#FFF4D6] shadow-[0_30px_60px_rgba(24,18,3,0.45)] opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-[opacity,transform] duration-300"
              >
                <img src={b.src} alt="" aria-hidden="true" className="w-full h-full object-cover object-bottom scale-[1.9] translate-y-[10%]" />
                <span className="absolute bottom-2 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#181203] text-[#FFD000] text-[10px] sm:text-xs font-bold px-3 py-1">
                  {b.label}
                </span>
              </div>
              <motion.img
                data-testid={`hero-juice-stream-${b.id}`}
                src={b.src}
                alt={`${b.id} juice being poured into a 16 oz plastic bottle`}
                className="w-full drop-shadow-[0_24px_30px_rgba(24,18,3,0.4)] transition-transform duration-500 group-hover:-translate-y-2"
                animate={{ y: [0, -6, 0] }}
                transition={{ duration: 4 + i * 0.4, repeat: Infinity, ease: "easeInOut", delay: 2.4 }}
              />
            </motion.div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 px-[3%] mt-5 text-center" data-testid="hero-flavor-lists">
        {groups.map((g, i) => (
          <motion.div
            key={g.base}
            className="space-y-1.5 sm:space-y-2"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.1 + i * 0.1, duration: 0.7 }}
          >
            {g.items.map((v, j) => (
              <Link
                key={v.id}
                to={`/shop#item-${v.id}`}
                data-testid={`hero-flavor-link-${v.id}`}
                className={`block text-[10px] sm:text-[13px] font-bold uppercase tracking-[0.12em] leading-snug transition-colors ${
                  j === 0
                    ? "text-[#181203] underline underline-offset-4 decoration-2 decoration-[#181203]"
                    : "text-[#2B2008]/75 hover:text-[#181203] hover:underline hover:underline-offset-4"
                }`}
              >
                {v.name}
              </Link>
            ))}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
